function showElementsOnload() {
  const elements = document.getElementsByClassName('hide-onload');
  [...elements].forEach((element, index) => {
    const isDelayed = element.classList.contains('hide-onload--delayed');
    if (isDelayed) {
      setTimeout(() => {
        element.classList.add('hide-onload--show');
      }, 500);
    } else {
      element.classList.add('hide-onload--show');
    }
  });
}

function goToAnchor() {
  const anchors = [
    '#start',
    '#keynotes',
    '#schedule',
    '#workshops',
    '#exhibition',
    '#venue',
    '#diversity',
    '#dates',
    '#about'
  ];
  const sectionIndex = anchors.indexOf(window.location.hash);
  const section = document.getElementsByClassName('module-section')[
    sectionIndex
  ];

  if (section !== undefined) {
    window.scrollTo({
      top: section.offsetTop - 20,
      behavior: 'smooth'
    });
  }
}

function onload() {
  window.addEventListener('load', () => {
    showElementsOnload();
    goToAnchor();
  });
}

export default onload;



// WEBPACK FOOTER //
// ./src/modules/snippets/onload.js